module.exports = __webpack_public_path__ + "img/banner-why-us.5de9a72.png";